//
//
//
//
//
//

import Colorable from "../../mixins/Colorable";
import TextSizeable from "../../mixins/TextSizeable";

export default {
    name: "CardSubtitle",

    mixins: [TextSizeable, Colorable],

    props: {
        // Whether the card title has some content with additional spacing right below it
        // which causes a too large overall spacing between the title and the content.
        // Therefore, setting this to true will decrease the bottom spacing of the title.
        spacedContent: {
            type: Boolean,
            default: false
        }
    }
}
